module.exports = __webpack_public_path__ + "static/media/explorar-hh-xs.18a64462.jpg";